import { IManagableObject } from "../../IManagableObject";

export class NotificationViewModel implements IManagableObject {
  Id: number = 0;
  UserId: number = 0;
  Name: string;
  EventType: string = "SPEED";
  NotifyOperator: boolean = true;
  From: string = "00:00";
  Till: string = "23:59";
  Schedule: string = "";
  Mask: number = 255;
  RepeatPeriod: number = 0;
  MinDuration: number = 0;
  MinDelayBetween: number = 0;
  StartCommandId: number = 0;
  StartCommandName: string = "None";
  StopCommandId: number = 0;
  StopCommandName: string = "None";
  HttpRequest: string = "";
  Phone: string = "";
  Email: string = "";
  TrackerIds: number[] = [];
  InGeozones: number[] = [];
  OutOfGeozones: number[] = [];
  MinValue: number = null;
  MaxValue: number = null;
  TextTemplate = "";
  TrendName = "";
  Disabled = false;
  Groups: number[] = [];


  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.EventType = data["eventType"];
      this.From = this.millisecondsToTime(data["activeFrom"]);
      this.Till = this.millisecondsToTime(data["activeTill"]);
      this.Mask = data["workingDays"];
      this.RepeatPeriod = data["repeatPeriod"];
      this.MinDuration = data["minDuration"];
      this.MinDelayBetween = data["minDelayBetween"];
      this.StartCommandId = data["startCommandTemplateId"] ?? 0;
      // this.StartCommandName = data["startCommandTemplateName"];
      this.StopCommandId = data["resetCommandTemplateId"] ?? 0;
      // this.StopCommandName = data["resetCommandTemplateName"];
      this.Phone = data["phone"];
      this.Email = data["email"];
      this.TrackerIds = data["objectIds"];
      this.InGeozones = data["inGeozonesIds"];
      this.OutOfGeozones = data["outOfGeozonesIds"];
      this.HttpRequest = data["httpRequest"];
      this.MinValue = data["minValue"];
      this.MaxValue = data["maxValue"];
      this.TextTemplate = data["textTemplate"];
      this.TrendName = data["sensorName"];
      this.Disabled = data["disabled"];
      this.Groups = data["groupIds"];
      this.NotifyOperator = data["notifyOperator"];
    }
  }

  static fromJS(data: any): NotificationViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new NotificationViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean = false;

  private millisecondsToTime(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
    const minutes = Math.floor((totalSeconds % 3600) / 60).toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }
}

export class CreateNotificationViewModel {
  Id: number;
  UserId: number;
  Name: string;
  EventType: string;
  ActiveFrom: number;
  ActiveTill: number;
  Schedule: string;
  WorkingDays: number;
  RepeatPeriod: number;
  MinDuration: number;
  MinDelayBetween: number;
  StartCommandTemplateId: number | null;
  ResetCommandTemplateId: number | null;
  HttpRequest: string;
  Phone: string;
  Email: string;
  ObjectIds: number[];
  InGeozonesIds: number[];
  OutOfGeozonesIds: number[];
  MinValue: number | null;
  MaxValue: number | null;
  TextTemplate: string;
  SensorName: string;
  Disabled: boolean;
  NotifyOperator: boolean;
  GroupIds: number[];
  constructor(data: any) {
    this.Id = data.Id;
    // this.UserId = data.UserId;
    this.Name = data.Name;
    this.EventType = data.EventType;
    this.ActiveFrom = this.timeToMilliseconds(data.From);
    this.ActiveTill = this.timeToMilliseconds(data.Till);
    this.Schedule = data.Schedule;
    this.WorkingDays = data.Mask;
    this.RepeatPeriod = data.RepeatPeriod;
    this.MinDuration = data.MinDuration;
    this.MinDelayBetween = data.MinDelayBetween;
    this.StartCommandTemplateId = data.StartCommandId == 0 ? null : data.StartCommandId;
    this.ResetCommandTemplateId = data.StopCommandId == 0 ? null : data.StopCommandId;
    this.HttpRequest = data.HttpRequest;
    this.Phone = data.Phone;
    this.Email = data.Email;
    this.ObjectIds = data.TrackerIds;
    this.InGeozonesIds = data.InGeozones;
    this.OutOfGeozonesIds = data.OutOfGeozones;
    this.MinValue = data.MinValue;
    this.MaxValue = data.MaxValue;
    this.TextTemplate = data.TextTemplate;
    this.SensorName = data.TrendName;
    this.Disabled = data.Disabled;
    this.GroupIds = data.Groups;
    this.NotifyOperator = data.NotifyOperator;
  }

  private timeToMilliseconds(time: string) {
    const [hours, minutes] = time.split(':').map(Number);
    return (hours * 3600 + minutes * 60) * 1000;
  }

}
